import { getAPIErrorMessage } from 'api';
export const openSnakeError = (error) => ({
    type: 'ERROR_SNAKE__OPEN',
    error,
});
export const openSnakeAPIError = (error) => ({
    type: 'ERROR_SNAKE__OPEN',
    error: getAPIErrorMessage(error, 'Ошибка'),
});
export const closeSnakeError = () => ({
    type: 'ERROR_SNAKE__CLOSE',
});
